export default __webpack_public_path__ + "static/media/Lang_Dash.8f6c9e25.svg";